import consultRequestCreator from '../../consultRequestCreator';
import urlConstants from '../../../constants/urlConstants.js';

export function fetchSymptoms() {
  return consultRequestCreator
    .get(urlConstants.SYMPTOMS)
    .then(response => response.data.symptoms);
}
